import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Trash2, Plus } from "lucide-react";
import { toast } from "sonner";

function Field({ label, children }) {
  return (
    <div className="space-y-1.5">
      <Label className="text-[11px] uppercase tracking-widest text-slate-600 font-medium">{label}</Label>
      {children}
    </div>
  );
}

export default function ChecklistMaster() {
  const [rows, setRows] = useState([]);
  const [label, setLabel] = useState("");

  const load = async () => setRows((r => Array.isArray(r) ? r : [])((await api.get("/checklist-master")).data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!label.trim()) return;
    try {
      await api.post("/checklist-master", { label });
      setLabel("");
      toast.success("Checklist item added");
      load();
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); }
  };

  const remove = async (id) => {
    await api.delete(`/checklist-master/${id}`);
    load();
  };

  return (
    <Layout>
      <div className="mb-8">
        <div className="text-[11px] uppercase tracking-[0.2em] text-yellow-600 font-semibold mb-1">Master</div>
        <h1 className="text-3xl sm:text-4xl tracking-tight font-semibold text-slate-900" style={{ fontFamily: "var(--font-heading)" }}>Checklist</h1>
        <p className="text-slate-500 text-sm mt-2">These items auto-populate on every new job card.</p>
      </div>
      <div className="grid lg:grid-cols-3 gap-6">
        <Card className="p-5 border-slate-200 lg:col-span-2">
          <div className="text-lg font-semibold mb-3" style={{ fontFamily: "var(--font-heading)" }}>Default Checklist Items</div>
          <div className="space-y-2">
            {rows.length === 0 && <div className="text-sm text-slate-500 py-6 text-center border border-dashed border-slate-300 rounded">No checklist items yet.</div>}
            {rows.map((c) => (
              <div key={c.id} className="flex items-center gap-3 border border-slate-200 rounded p-3 bg-white">
                <div className="w-6 h-6 rounded bg-slate-100 grid place-items-center text-[10px] font-mono text-slate-600">{c.order + 1}</div>
                <span className="flex-1 text-sm">{c.label}</span>
                <Button variant="ghost" size="icon" onClick={() => remove(c.id)}><Trash2 className="w-4 h-4" /></Button>
              </div>
            ))}
          </div>
        </Card>
        <Card className="p-5 border-slate-200">
          <div className="text-lg font-semibold mb-3" style={{ fontFamily: "var(--font-heading)" }}>Add Item</div>
          <form onSubmit={submit} className="space-y-3">
            <Field label="Label *"><Input value={label} onChange={(e) => setLabel(e.target.value)} placeholder="e.g. QA sample approved" required /></Field>
            <Button type="submit" className="w-full bg-slate-900 text-white hover:bg-slate-800"><Plus className="w-4 h-4 mr-2" /> Add</Button>
          </form>
        </Card>
      </div>
    </Layout>
  );
}
